// extracted by mini-css-extract-plugin
export var heading = "header-module--heading--SJulY";
export var image = "header-module--image--OwuXq";
export var left = "header-module--left--ah17h";
export var right = "header-module--right--VYaqP";
export var section = "header-module--section--PM-9D";
export var show = "header-module--show--CISpk";
export var subheading = "header-module--subheading--Omj6N";